<template>
  <div class="row justify-content-center py-2">
    <div class="col-md-4">
      <AutomationFlowStraight v-if="!firstItem" class="mb-2" />
      <CCard class="mb-0 px-2" :class="getCardClasses()" @click="selectBlock">
        <CCardBody>
          <CRow class="justify-content-top pr-2">
            <CCol class="pt-1" :class="setHeaderSize()">{{ header }}</CCol>
            <CCol sm="1">
              <CIcon
                v-if="state == stateEnum.VALID"
                name="checkCircle"
                size="custom-size"
                :height="24"
                viewBox="0 0 32 32"
                class="icon-validation-positive"
              />
              <CIcon
                v-if="state == stateEnum.INVALID"
                name="refused"
                size="custom-size"
                :height="24"
                viewBox="0 0 32 32"
                class="icon-validation-negative"
              />
              <CIcon
                v-if="state == stateEnum.NOT_EDITED || state == stateEnum.NOT_VALIDATED"
                name="cilPencil"
                size="custom-size"
                :height="24"
                viewBox="0 0 32 32"
                class="icon-validation-editing"
              />
            </CCol>
          </CRow>
          <slot name="body"></slot>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>
<script>
import AutomationFlowStraight from './AutomationFlowStraight.vue'
import { TRIGGER_STEPS_STATES } from '../../constants'

// Criado só pra catalogar os tamanhos
const headerSizesEnum = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export default {
  components: {
    AutomationFlowStraight,
  },
  props: {
    id: {
      type: Number,
      default: () => 0,
    },
    header: {
      type: String,
      default: () => '',
    },
    headerSize: {
      type: String,
      default: () => 'md',
    },
    firstItem: {
      type: Boolean,
      default: () => false,
    },
    selected: {
      type: Boolean,
      default: () => false,
    },
    state: {
      type: Number,
      default: () => 4,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stateEnum: TRIGGER_STEPS_STATES,
    }
  },
  methods: {
    selectBlock() {
      this.$emit('select-item', this.id)
    },
    setHeaderSize() {
      switch (this.headerSize) {
        case headerSizesEnum.lg:
          return 'h4'
        case headerSizesEnum.md:
          return 'h5'
        case headerSizesEnum.sm:
          return 'h6'
        default:
          return 'h5'
      }
    },
    getActiveSelectionClass() {
      let isActive = 'active-selection'
      if (!this.firstItem) isActive += ' active-selection-notDetails'

      return isActive
    },
    getDisabledClass() {
      if (!this.disabled) return

      return 'opacity-50 pointer-events-none'
    },
    getCardClasses() {
      let classes = ''

      if (this.selected) {
        classes += this.getActiveSelectionClass() + ' '
      }

      if (this.disabled) {
        classes += this.getDisabledClass()
      }

      return classes
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-validation-positive {
  background-color: rgba($success, 0.1);
  color: rgba($success, 0.8);
  border-radius: 20px;
  border-color: rgba($success, 0.1);
}

.icon-validation-negative {
  background-color: rgba($error, 0.1);
  color: rgba($error, 0.8);
  border-radius: 20px;
  border-color: rgba($error, 0.1);
}

.icon-validation-editing {
  background-color: transparent;
  color: $gray-400;
  border-radius: 20px;
  border-color: rgba($error, 0.1);
}

.active-selection {
  border: 1px $primary solid !important;
}
.active-selection-notDetails {
  border-left: 10px $primary solid !important;
}
</style>
